export default {
  sizes: ["Бит", "КБ", "МБ", "ГБ", "ТБ", "ПБ"],
  uploadNoMoreFiles: "Кеминде {maxFileCount} файлдан көп жүктөбөңүз",
  maxFileSize: {
    upppercase: "Жогорку чеги {maxFileSize}",
    lowercase: "жогорку чеги {maxFileSize}",
  },
  maxUploadFilesAmountWithSize:
    "Ар бир файлдын көлөмү {maxFileSize} чейин, жалпы {maxFilesAmount} файлга чейин",
  minMaxUploadFilesAmountWithSize:
    "{from}дөн {to} файлга чейин, ар бир файлдын көлөмү {size}дан ашпашы керек",
  oneUploadFileWithMaxsize: "1 файлдын көлөмү {maxFileSize} чейин",
  newFileAction: {
    moveOr: "Тартсаңыз же",
    upload: "файлдарды жүктөңүз",
  },
  validation: {
    maxSize: "Файлдын максималдуу көлөмү ашып кетти",
    unsupportedFileType: "Файлдын форматы колдоого алынган эмес",
    addedUnsupportedFiles: "Колдоого алынбаган файлдар кошулду",
    totalSizeNotMoreThan: "Файлдардын жалпы көлөмү {totalSize} ашпашы керек",
    exceedFilesAmountLimit: "Жүктөлө турган файлдардын саны боюнча чектен ашты",
  },
  uploadPhoto: "Сүрөт жүктөө",
  photoAspect: "Сүрөттүн катышы — {aspect}",
  pictureEditing: "Сүрөттү түзөтүү",
  selectedAreaWillDisplay:
    "Тандалган аймак RC PAYде сиздин мекемеңизди көрүүдө көрсөтүлөт.",
  currentImageFrom: "{total} сүрөттөн {from}-сүрөт",
};
